export class SellerAccountModel {
  sellerAccountId: number;
  sellerId: number;
  username: string;
  firstname: string;
  lastname: string;
  countryCode: string;
  contactNumber: string;
  timezone: string;
  emailVerified: boolean;
  constructor(sellerAccount: any) {
    this.sellerAccountId = sellerAccount.sellerAccountID;
    this.sellerId = sellerAccount.sellerID;
    this.username = sellerAccount.username;
    this.firstname = sellerAccount.firstname;
    this.lastname = sellerAccount.lastname;
    this.countryCode = sellerAccount.countryCode ?? '';
    this.contactNumber = sellerAccount.contactNumber;
    this.timezone = sellerAccount.timezone;
    this.emailVerified = sellerAccount.emailVerified;
  }
  
}
